<template>
  <CatalogSelect
    :id="id"
    :is-disabled="isDisabled"
    :fetchData="fetchData"
    :searchData="searchData"
    v-on="$listeners"
  >
    <template v-slot:create-catalog="{ refresh }">
      <task-worker-status @refresh="refresh"/>
    </template>
  </CatalogSelect>
</template>

<script>
import catalogs from "../../../network/catalogs";
import CatalogSelect from "../CatalogSelect.vue";
import TaskWorkerStatus from "./TaskWorkerStatus";

export default {
  name: "TaskWorkerStatusSelect",
  components: { CatalogSelect, TaskWorkerStatus },
  mixins: [ catalogs ],
  props: {
    isDisabled: { type: Boolean },
    id: { type: Number },
  },
  methods: {
    async fetchData(id) {
      return await this.getTaskWorkerStatusById(id);
    },
    async searchData(query) {
      return await this.getTaskWorkerStatusesSearch(query);
    },
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Catalogs/TaskWorkerStatuses/TaskWorkerStatusSelect.vue